import { render, staticRenderFns } from "./aftersale_order_workhours.vue?vue&type=template&id=f3e39a64&scoped=true"
import script from "./aftersale_order_workhours.vue?vue&type=script&lang=js"
export * from "./aftersale_order_workhours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e39a64",
  null
  
)

export default component.exports